import { Stack, Typography, Checkbox } from '@mui/material';
import React from 'react';
import { useMemo, } from 'react';
import MobilePhoneStatus from '../../CustomComponents/MobilePhoneStatus';
import { AssignmentLateRounded, AssignmentTurnedInRounded, HourglassDisabledRounded, HourglassFullRounded } from '@mui/icons-material';


function TextingPreviewSummary({ allPhysicians, onSelectionChange, selectedIds = [] }) {
    const selectedSet = useMemo(() => new Set(selectedIds || []), [selectedIds]);

    const displayedPhysicians = useMemo(() => {
        return Object.values(allPhysicians).slice().sort((a, b) => a.last_name.localeCompare(b.last_name));
    }, [allPhysicians]);

    const displayedIds = useMemo(() => displayedPhysicians.map((p) => p.id), [displayedPhysicians]);

    const allDisplayedSelected = displayedIds.length > 0 && displayedIds.every((id) => selectedSet.has(id));
    const someDisplayedSelected = displayedIds.some((id) => selectedSet.has(id));
    
    return (
        <Stack p={4} justifyContent='space-between' height='100%'>
            <Stack spacing={2}>
                <Typography variant='heavy' sx={{ 'fontSize': '16px' }}># of Physicians Projected to Receive Text Message: {selectedIds.length}</Typography>
                <Stack direction='row' alignItems='center' spacing={1}>
                    <Checkbox
                        size='small'
                        checked={allDisplayedSelected}
                        indeterminate={someDisplayedSelected && !allDisplayedSelected}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            const next = new Set();
                            if (checked) displayedIds.forEach((id) => next.add(id));
                            if (onSelectionChange) onSelectionChange(Array.from(next));
                            return next;
                        }}
                    />
                    <Typography variant='heavy' sx={{ 'fontSize': '14px' }}>Select All / None</Typography>
                </Stack>
                <Stack spacing={1} ml={1}>
                    <Typography variant='heavy' sx={{ 'fontSize': '16px' }}>Physicians Expected to Receive Text Message:</Typography>
                    {displayedPhysicians.map((physician) => (
                        <Stack key={physician.id} direction='row' alignItems='center' spacing={1}>
                            <Checkbox
                                size='small'
                                checked={selectedSet.has(physician.id)}
                                onChange={() => {
                                    if (!onSelectionChange) return;
                                    const next = new Set(selectedSet);
                                    if (next.has(physician.id)) next.delete(physician.id);
                                    else next.add(physician.id);
                                    onSelectionChange(Array.from(next));
                                }}
                                disabled={physician.do_not_text}
                            />
                            <Typography key={`${physician.id}-name`} variant='light' sx={{ 'fontSize': '14px' }}>{physician.last_name}, {physician.first_name}</Typography>
                            <MobilePhoneStatus physician={physician} clickable={false} />
                            { physician.was_recently_texted ? 
                                <HourglassDisabledRounded sx={{ color: 'error.main' }} titleAccess='Physician has received bulk text in past 24 hours.' /> :
                                <HourglassFullRounded sx={{ color: 'success.main' }} titleAccess='Physician has not received bulk text in past 24 hours.' />
                            }
                            { physician.has_reviewed_any_current_drafts ?
                                <AssignmentTurnedInRounded sx={{ color: 'success.main' }} titleAccess='Physician has some completed card reviews.' /> :
                                <AssignmentLateRounded sx={{ color: 'warning.main' }} titleAccess='Physician has not completed any card reviews.' />
                            }
                        </Stack>
                    ))}
                </Stack>
            </Stack>
        </Stack>
    );
}


export default TextingPreviewSummary;
